import * as _ from 'lodash'

const getDefaultState = () => {
  const defaults = {
    table: [],
    lists: [],
    detail: {
      id: null,
      categoryId: null,
      categoryName: '',
      title: '',
      detail: ''
    },
    search: {
      keyword: '',
      start: 0,
      per_page: 30,
      search_order: 'score',
      ascending: 'desc',
      load: true
    },
    pagenation: {
      count: null,
      currentPage: 1
    },
    topPageId: null,
    scrollTo: null,
    currentContentId: null,
    currentCategoryId: null
  }

  return defaults
}

const guide = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    keyword: (state) => state.search.keyword,
    isSearch: (state) => !!state.search.keyword,
    table: (state) => state.table,
    lists: (state) => state.lists,
    searchRequest: (state) => {
      return {
        keyword: state.search.keyword,
        start: state.search.start,
        per_page: state.search.per_page,
        search_order: state.search.search_order,
        ascending: state.search.ascending
      }
    },
    countRequest: (state) => {
      return {
        keyword: state.search.keyword
      }
    },
    currentId: (state) => state.currentContentId,
    currentCategoryId: (state) => state.currentCategoryId,
    topPageId: (state) => state.topPageId
  },
  mutations: {
    setTable: (state, lists) => {
      state.table.splice(0, state.table.length)
      state.table.push(...lists)
    },
    setLists: (state, lists) => {
      state.lists.splice(0, state.lists.length)
      state.lists.push(...lists)
    },
    setCount: (state, count) => {
      state.pagenation.count = count
    },
    resetAllState: (state) => {
      Object.assign(state, getDefaultState())
    },
    setId: (state, id) => {
      state.currentContentId = id
    },
    setCategoryId: (state, id) => {
      state.currentCategoryId = id
    },
    setTopPageId: (state, id) => {
      state.topPageId = id
    },
    scrollTo: (state, top) => {
      state.scrollTo = top
    },
    setDetail: (state, obj) => {
      state.detail.id = obj.id
      state.detail.title = obj.title
      state.detail.detail = obj.detail
      state.detail.categoryId = obj.categoryId
      state.detail.categoryName = obj.categoryName
    },
    setKeyword: (state, keyword) => {
      state.search.keyword = keyword
    },
    pageReset: (state) => {
      state.pagenation.count = null
      state.pagenation.currentPage = 1
      state.search.start = 0
    },
    setPageNation: (state, { currentPage, start }) => {
      state.pagenation.currentPage = currentPage
      state.search.start = start
    },
    search: (state, bool) => {
      state.search.load = bool
    }
  },
  actions: {
    setTable({ commit }, lists) {
      commit('setTable', lists)
    },
    setLists({ commit }, lists) {
      commit('setLists', lists)
    },
    setCount({ commit }, count) {
      commit('setCount', count)
    },
    resetAllState({ commit }) {
      commit('resetAll')
    },
    currentOpen({ commit, state }) {
      // const recursiveHasGuideId = (lists) => {
      //   _.map
      // }
      // const currentTable = _.cloneDeep(state.table)
      // const table = recursiveOpen(currentTable)
    },
    allOpen({ commit, state }) {
      const recursiveOpen = (lists) => {
        return _.map(lists, list => {
          list.isOpen = true
          if (list.hasChild) {
            list.children = recursiveOpen(list.children)
          }

          return list
        })
      }
      const currentTable = _.cloneDeep(state.table)
      const table = recursiveOpen(currentTable)
      commit('setTable', table)
    },
    allClose({ commit, state }) {
      const recursiveClose = (lists) => {
        return _.map(lists, list => {
          list.isOpen = false
          if (list.hasChild) {
            list.children = recursiveClose(list.children)
          }

          return list
        })
      }
      const currentTable = _.cloneDeep(state.table)
      const table = recursiveClose(currentTable)
      commit('setTable', table)
    },
    setCurrentId({ commit }, id) {
      commit('setId', id)
    },
    setCurrentCategoryId({ commit }, id) {
      commit('setCategoryId', id)
    },
    setTopPageId({ commit }, id) {
      commit('setTopPageId', id)
    },
    scrollTo({ commit }, top) {
      commit('scrollTo', top)
    },
    setDetail({ commit }, data) {
      const {
        id,
        title,
        detail,
        category_id: categoryId,
        category_naame: categoryName
      } = data
      
      commit('setDetail', {
        id, title, detail, categoryId, categoryName
      })
    },
    setKeyword({ commit }, keyword) {
      commit('setKeyword', keyword)
    },
    pageReset({ commit }) {
      commit('pageReset')
    },
    setPageNation({ commit }, obj) {
      commit('setPageNation', obj)
    },
    search({ commit }, bool) {
      commit('search', bool)
    }
  }
}

export default guide
